module.exports = __webpack_public_path__ + "img/default-avstar.f4005cef.png";